import HamburgerMenu from './HamburgerMenuPublic';
import HamburgerMenuPublic from './HamburgerMenuPublic';

// import './Header.css';
import ItemsAndPostsIcon from './ItemsAndPostsIcon';
import MyInfoIcon from './MyInfoIcon';
import SettingsIcon from './SettingsIcon';
import Logo from './logo';
import ProfileMenuPublic from './ProfileMenuPublic';
import MobileLogo from './MobileLogo';
import { NavLink } from 'react-router-dom';
import CSS from './HeaderPublic.module.css';

export default function HeaderPublic() {
  return (
    <>
      <div className={CSS.header}>
        <div className={CSS.headerContent}>
          <div className={CSS.logoWrap}>
            <MobileLogo />
            <Logo />
          </div>
          <div className={CSS.iconsWrap}>
            <NavLink to='/swapandtop/login'>
              <button className={CSS.newPostBtn}>Log in</button>
            </NavLink>

            <ProfileMenuPublic />
            <HamburgerMenuPublic />
          </div>
        </div>
      </div>
    </>
  );
}
